import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Portal from '../Portal';
import classNames from '../../utils/classNames';
import styles from './Modal.module.css';
const Modal = ({ children, className, containerClassName, actionsClassName, actions, onClose = () => { }, disableEscapeClose = false, testId, }) => {
    const ref = React.useRef(null);
    React.useEffect(() => {
        const listener = (event) => {
            if (disableEscapeClose === false) {
                if (ref.current && ref.current.contains(event.target) === false) {
                    onClose();
                }
            }
        };
        document.addEventListener('mousedown', listener);
        return () => document.removeEventListener('mousedown', listener);
    });
    return (_jsx(Portal, Object.assign({ id: "modalportal" }, { children: _jsx("div", Object.assign({ "data-testid": testId, className: classNames(className, styles.modalContainer) }, { children: _jsxs("div", Object.assign({ ref: ref, className: classNames(containerClassName, styles.modalContent) }, { children: [_jsx("div", Object.assign({ className: styles.infoContainer }, { children: children }), void 0), actions && (_jsx("div", Object.assign({ className: classNames(styles.actionsContainer, actionsClassName) }, { children: actions }), void 0))] }), void 0) }), void 0) }), void 0));
};
export default Modal;
